module.exports = __webpack_public_path__ + "img/critical-error.bede6b4b.svg";